import { FileSharingService } from '../Api/Api';

export const shareItem = async (
  itemId: string,
): Promise<string | undefined> => {
  const API = new FileSharingService();
  const { data } = await API.shareItem({ libraryItemId: itemId });
  return data?.url;
};
